'use client'

import { Divider, Grid, Stack, Typography } from '@mui/material'
import moment from 'moment'
import { gql, useQuery } from '@apollo/client'
import { useContext, useEffect } from 'react'
import {
	GetSubscription,
	lightPurple,
	Logger,
	Module,
	Section,
	TextBlock
} from '@wolfdanepug/common-react'
import { PaymentMethodModule } from '../../../components/payment-method/PaymentMethodModule'
import PlanCard from '../../../components/plan/PlanCard'
import SubscriptionSummary from '../../../components/subscription/SubscriptionSummary'
import { profileColors } from '../../../constants'
import dashboard from '../../../dashboard'
import { getUpcomingBillingDate } from '../../../utils'
import { PageContext } from '../../../context/page'

export default function Subscription() {
	const { data, loading, error } = useQuery(gql(GetSubscription))
	const { setPage } = useContext(PageContext)
	const subscription = data?.getSubscription

	useEffect(() => {
		setPage({
			title: 'Subscription',
			description: 'Manage Your Subscription'
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		error && Logger.error(error)
	}, [error])

	const upcomingBillingDate = getUpcomingBillingDate(subscription?.meta?.billingCycleStartDate)
	return (
		<>
			<Section>
				<Grid container spacing={3}>
					<Grid item xs={12} md={12} lg={6}>
						<Module {...dashboard.subscription}>
							<SubscriptionSummary
								title="Current Subscription"
								subscription={subscription}
								showModifyMessage={false}
								sx={{
									chip: {
										alignSelf: 'flex-start'
									}
								}}
							/>
						</Module>
					</Grid>
					<Grid item xs={12} sm={12} md={6} lg={3}>
						<Module
							color={lightPurple}
							sx={{
								content: {
									justifyContent: 'space-between',
									display: 'flex',
									height: '100%',
									flexDirection: 'column'
								}
							}}
						>
							<TextBlock
								sx={styles.dateBlock}
								title="Next Payment Date"
								text={
									upcomingBillingDate ? moment(upcomingBillingDate).format('MMMM Do, YYYY') : ''
								}
							/>
							<Divider />
							<TextBlock
								sx={styles.dateBlock}
								title="Next Delivery Date"
								text={
									subscription?.meta?.firstDeliveryDate
										? moment(subscription?.meta?.firstDeliveryDate).format('MMMM Do, YYYY')
										: ''
								}
							/>
						</Module>
					</Grid>
					<Grid item xs={12} sm={12} md={6} lg={3}>
						<PaymentMethodModule subscription={subscription} loading={loading} canModify={false} />
					</Grid>

					<Grid item xs={12}>
						<Module
							sx={{
								root: {
									background:
										'url(https://static.wixstatic.com/media/1b43b4_0010618a584a477497688ec38d74e5ec~mv2.jpg) center no-repeat',
									backgroundSize: 'cover'
								},
								content: {
									background: 'rgba(0,0,0,0.5)',
									minHeight: 500,
									display: 'flex',
									alignItems: 'flex-end'
								}
							}}
						>
							<Grid container spacing={8}>
								<Grid item xs={12} md={6}>
									<Stack gap={3}>
										<Typography variant="h3" color="white">
											Plans
										</Typography>
										<Typography variant="body1" color="white">
											You can modify your subscription plans at any time. *Modifying the serving
											size of the plan may change the subscription price.
										</Typography>
										<Typography variant="caption" color="white">
											*Any changes made to your subscription on or after the next payment date will
											take effect on the following billing cycle.
										</Typography>
									</Stack>
								</Grid>
								<Grid item xs={12} md={6}>
									<Grid container spacing={2}>
										{subscription?.plans.length > 0 &&
											subscription.plans.map((plan: any, index: number) => (
												<Grid key={plan.id} item xs={12} sm={12} md={12}>
													<PlanCard
														plan={plan}
														color={profileColors[index]}
														// actions={[
														// 	{
														// 		label: 'Modify',
														// 		link: `/subscription/${plan.id}`
														// 		// variant: 'contained'
														// 	}
														// ]}
													/>
												</Grid>
											))}
									</Grid>
								</Grid>
							</Grid>
						</Module>
					</Grid>
				</Grid>
			</Section>
		</>
	)
}

const styles = {
	dateBlock: {
		title: {
			color: '#757575'
		},
		text: {
			fontSize: '20px',
			color: '#000'
		}
	}
}
